import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Illustration from "../assets/Illustration.svg";
import WebDevelopment from "../assets/custom web.svg";
import AI from "../assets/ai.svg";
import Grow from "../assets/seo.svg";

const slides = [
  {
    title: "Your Path To A Digital Revolution Starts Here!",
    subtitle:
      "We strive to empower businesses with cutting-edge solutions, propelling them to new heights of success.",
    image: Illustration,
    button1_text: "Let's Connect",
    button2_text: "Explore Services",
  },
  {
    title: "Custom Web Development",
    subtitle:
      "High-performance websites and web apps built with modern frameworks and clean architecture.",
    image: WebDevelopment,
    button1_text: "Get a Quote",
    button2_text: "See Our Work",
  },
  {
    title: "AI & Automation Solutions",
    subtitle:
      "Reliable data pipelines and task automation to save hours every week.",
    image: AI,
    button1_text: "Learn More",
    button2_text: "Request a Demo",
  },
  {
    title: "Grow Your Business",
    subtitle: "Data-driven SEO to grow qualified traffic and conversions.",
    image: Grow,
    button1_text: "Start Growing",
    button2_text: "Case Studies",
  },
];

const HeroCarousel = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: false,
    arrows: true,
  };

  return (
    <Slider {...settings}>
      {slides.map((slide, index) => (
        <div key={index} className="relative">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-10 relative">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div className="text-center md:text-left">
                <h1 className="text-4xl sm:text-5xl md:text-7xl font-extrabold tracking-tight text-secondary">
                  {slide.title}
                </h1>
                <p className="mt-6 max-w-xl text-lg sm:text-xl text-secondary mx-auto md:mx-0">
                  {slide.subtitle}
                </p>
                <div className="mt-10 flex flex-col sm:flex-row items-center gap-4 justify-center md:justify-start">
                  <a
                    href="#contact"
                    className="w-full sm:w-auto px-6 py-4 rounded-md bg-secondary text-accent hover:bg-primary hover:text-secondary shadow-lg transition-all duration-300 transform hover:-translate-y-1"
                  >
                    {slide.button1_text}
                  </a>
                  <a
                    href="#services"
                    className="w-full sm:w-auto px-6 py-4 rounded-md border border-secondary text-secondary hover:bg-primary hover:text-secondary hover:border-primary shadow-sm transition-all duration-300 transform hover:-translate-y-1"
                  >
                    {slide.button2_text}
                  </a>
                </div>
              </div>
              <div className="relative flex justify-center">
                <img
                  src={slide.image}
                  alt="Hero illustration"
                  className="w-full drop-shadow-lg"
                  loading="eager"
                  decoding="async"
                />
              </div>
            </div>
          </div>
        </div>
      ))}
    </Slider>
  );
};

export default HeroCarousel;
